<template>
  <div id="site-details">
    <div class="section-title">Site Details</div>
    <div v-if="currentSite" class="card">
      <div class="card-body">
        <div class="row details-row">
          <div class="col">
            <div class="row font-weight-bold">Site Address:</div>
            <div class="row"> {{currentSite.Site_Address__c}}</div>
            <div class="row"> {{currentSite.City__c}},
               {{currentSite.State__c}} {{currentSite.Zip__c}}
            </div>
          </div>
        </div>
        <div class="row details-row">
          <span class="details-label">County:</span>
          {{ currentSite.County__c || 'N/A' }}
        </div>
        <div class="row details-row">
          <span class="details-label">Watershed Name:</span>
          {{ currentSite.Watershed_Name__c || 'N/A' }}
        </div>
        <div class="row details-row">
          <span class="details-label">Subwatershed Name:</span>
          {{ currentSite.Subwatershed_Name__c || 'N/A' }}
        </div>
        <div class="row details-row">
          <span class="details-label">Site Acreage:</span>
          {{ currentSite.Site_Acreage__c || 'N/A' }}
        </div>
        <div class="row details-row">
          <span class="details-label">Primary Land Use:</span>
          {{ currentSite.Primary_Land_Use__c || 'N/A' }}
        </div>
        <div class="row">
          <span class="details-label">Contacts:</span>
          {{ (orderedOrganizations.length || orderedContacts.length) ? '' : 'None' }}
        </div>
        <div v-for="organization in orderedOrganizations" :key="organization.Id">
          <div class="row">
            <a class="font-weight-bold" target="_blank"
              :href="`${config.insightly.organizationUrl}${organization.ORGANISATION_ID}`">
              {{ organization.ORGANISATION_NAME }}
            </a>
            - {{ organization.Role__c || 'N/A' }}
            <template v-if="organization.Primary__c"> (Primary)</template>
          </div>
        </div>
        <div v-for="contact in orderedContacts" :key="contact.Id">
          <div class="row">
            <a class="font-weight-bold" target="_blank"
               :href="`${config.insightly.contactUrl}${contact.Contact__c}`">
              {{ contact.FIRST_NAME }} {{ contact.LAST_NAME }}
            </a>
            <template v-if="contact.Role__c"> - {{ contact.Role__c }} </template>
            <template v-else> - N/A </template>
            <template v-if="contact.Primary__c"> (Primary)</template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';

export default {
  name: 'Details',
  computed: {
    ...mapState(['currentSite', 'config']),
    orderedOrganizations() {
      if (this.currentSite.organizations) {
        return this.currentSite.organizations
          .slice()
          .sort((a, b) => {
            // sort by Primary first, then by first name, then by last name
            if (a.Primary__c && !b.Primary__c) {
              return -1;
            }
            if (!a.Primary__c && b.Primary__c) {
              return 1;
            }
            return a.ORGANISATION_NAME.localeCompare(b.ORGANISATION_NAME);
          });
      }
      return [];
    },
    orderedContacts() {
      if (this.currentSite.contacts) {
        const sorted = this.currentSite.contacts
          .slice()
          .sort((a, b) => {
            // sort by Primary first, then by first name, then by last name
            if (a.Primary__c && !b.Primary__c) {
              return -1;
            }
            if (!a.Primary__c && b.Primary__c) {
              return 1;
            }
            const firstNameCompare = a.FIRST_NAME.localeCompare(b.FIRST_NAME);
            if (firstNameCompare !== 0) {
              return firstNameCompare;
            }
            return a.LAST_NAME.localeCompare(b.LAST_NAME);
          });
        return sorted;
      }
      return [];
    },
  },
  mounted() {
  },
};
</script>
